"use client";

import Link from "next/link";

export interface ActionLink {
  href: string;
  label: string;
  external?: boolean;
  /** When present, fires this event before navigation so the click is
   * attributable in PostHog / GA4. Generic shape — the consumer page
   * names the event, this component never hardcodes it. */
  track?: {
    name: string;
    properties?: Record<string, unknown>;
  };
}

function trackAction(track: NonNullable<ActionLink["track"]>) {
  void import("@/lib/analytics-events").then(({ trackEvent }) => {
    trackEvent(track.name, track.properties);
  });
}

export function Action({ action, primary }: { action: ActionLink; primary?: boolean }) {
  const className =
    "inline-flex min-h-11 items-center justify-center rounded-xl px-5 text-button font-bold transition " +
    (primary
      ? "bg-surface-brand-strong text-text-on-brand hover:opacity-90"
      : "border border-border-default text-text-primary hover:bg-surface-brand-subtle");

  const handleClick = action.track ? () => trackAction(action.track!) : undefined;

  if (action.external) {
    return (
      <a
        href={action.href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={handleClick}
      >
        {action.label}
      </a>
    );
  }

  if (action.href.startsWith("#")) {
    return (
      <a href={action.href} className={className} onClick={handleClick}>
        {action.label}
      </a>
    );
  }

  return (
    <Link href={action.href} className={className} onClick={handleClick}>
      {action.label}
    </Link>
  );
}
